module.exports = __webpack_public_path__ + "static/media/Major Project EXTC 2021-22.719fa3d8.pdf";